const calculateDistance = (p1, p2, axis) => {
    axis = axis.toUpperCase();
    if (axis === "X") {
        return Math.abs(p2[0] - p1[0]);
    } else if (axis === "Y") {
        return Math.abs(p2[1] - p1[1]);
    } else {
        throw new Error("Axis must be 'X' or 'Y'");
    }
};

const isBetween = (a, b, c, axis) => {
    axis = axis.toUpperCase();
    if (axis === "X") {
        return Math.min(a[0], c[0]) <= b[0] && b[0] <= Math.max(a[0], c[0]);
    } else if (axis === "Y") {
        return Math.min(a[1], c[1]) <= b[1] && b[1] <= Math.max(a[1], c[1]);
    } else {
        throw new Error("Axis must be 'X' or 'Y'");
    }
};

const checkAxis = (stencil1, stencil2, mask1, mask2, axis, region = null) => {
    const p1Between = isBetween(stencil1, mask1, stencil2, axis);
    const p2Between = isBetween(stencil1, mask2, stencil2, axis);

    const stencilDistance = calculateDistance(stencil1, stencil2, axis);
    const maskDistance = calculateDistance(mask1, mask2, axis);

    return [p1Between, p2Between, stencilDistance, maskDistance];
};

const minMaxOfMask = (bbox) => {
    let xmin = bbox[1]
    let ymin = bbox[0]
    let xmax = bbox[3]
    let ymax = bbox[2]

    return [
        [xmin * 128, ymin * 128],
        [xmax * 128, ymax * 128],
    ];
};

export const goodFrame = (stencilMin, stencilMax, bbox, currentRegion) => {
    console.log("goodframe ::: ", stencilMin, stencilMax, bbox, currentRegion)
    if (!bbox || bbox.length === 0) {
        return 3;
    }

    const [maskMin, maskMax] = minMaxOfMask(bbox);

    const [p1BetweenX, p2BetweenX, stencilDistanceX, maskDistanceX] = checkAxis(
        stencilMin,
        stencilMax,
        maskMin,
        maskMax,
        "X"
    );
    const [p1BetweenY, p2BetweenY, stencilDistanceY, maskDistanceY] = checkAxis(
        stencilMin,
        stencilMax,
        maskMin,
        maskMax,
        "Y"
    );

    if (currentRegion !== "Rear" && currentRegion !== "Front") {
        if (p1BetweenX && p2BetweenX && p1BetweenY && p2BetweenY) {
            if (
                0.9 * stencilDistanceX <= maskDistanceX &&
                maskDistanceX <= stencilDistanceX &&
                0.7 * stencilDistanceY <= maskDistanceY &&
                maskDistanceY <= stencilDistanceY
            ) {
                return 1;
            } else {
                return 2;
            }
        } else if (!p1BetweenX && !p2BetweenX) {
            if (
                stencilDistanceX <= maskDistanceX &&
                maskDistanceX <= 1.06 * stencilDistanceX &&
                0.7 * stencilDistanceY <= maskDistanceY &&
                maskDistanceY <= 1.06 * stencilDistanceY
            ) {
                return 1;
            } else {
                return 0;
            }
        }
    } else {
        if (p1BetweenX && p2BetweenX && p1BetweenY && p2BetweenY) {
            if (
                0.9 * stencilDistanceY <= maskDistanceY &&
                maskDistanceY <= stencilDistanceY &&
                0.7 * stencilDistanceX <= maskDistanceX &&
                maskDistanceX <= stencilDistanceX
            ) {
                return 1;
            } else {
                return 2;
            }
        } else if (!p1BetweenY && !p2BetweenY) {
            if (
                stencilDistanceY <= maskDistanceY &&
                maskDistanceY <= 1.06 * stencilDistanceY &&
                0.7 * stencilDistanceX <= maskDistanceX &&
                maskDistanceX <= 1.06 * stencilDistanceX
            ) {
                return 1;
            } else {
                return 0;
            }
        }
    }
    return 4
};